import { DataSource } from '@n7-frontend/core';
import { IMetadataViewerData } from '@n7-frontend/components';
import {Utils} from './utils';
export class PersonaInfoDS extends DataSource {
  protected transform(data): IMetadataViewerData {
    if (!data || !data.userData) {
      return;
    }

    const getIndirizzo = function(data){
      if(!data.userData.address){
        return `Informazione non disponibile`;
      }
      if(data.userData.address.fullAddress){
        return data.userData.address.fullAddress;
      }
      if(data.userData.address.municipality && data.userData.address.provinceCode){
        return `${data.userData.address.municipality} ${data.userData.address.provinceCode}`;
      }
      return `Informazione non disponibile`;
    }

    const getComuneNascita = function(data){
      if(!data.userData || !data.userData.birthPlace || !data.userData.birthPlace.municipality ) {
        return 'Dato non disponible';
      }
      return `${data.userData.birthPlace.municipality} `+ (data.userData.birthPlace.provinceCode ? `${data.userData.birthPlace.provinceCode}` : '');
    }

    let items = [{
      value: `${data.userData.givenName}`,
      label: `Nome`
    },
    {
      value: `${data.userData.familyName}`,
      label: `Cognome`
    },
    {
      value: `${data.userData.gender}`,
      label: `Sesso`
    },
    {
      value: getIndirizzo(data),
      label: `Indirizzo`
    },
    {
      value: Utils.formatDate(data.userData.birthDate) || `Informazione non disponibile`,
      label: `Data di nascita`
    },
    {
      value: getComuneNascita(data),
      label: `Comune di nascita`
    }];

    return {
      classes: 'example-class',
      group: [{
        items: items
      }]
    };
  }
}
